import React, { useEffect, useRef, useState } from "react";
import styles from "./BusinessImprovement.module.css";
import CommonBanner from "../common-component/common-banner/CommonBanner";
import { API_BASE_URL } from "configs/AppConfig";
import CommonEditorFile from "../common-component/common-editor-file/CommonEditorFile";
import { useLocation, useParams } from "react-router-dom";
import MetaDetails from "components/meta-details/MetaDetails";
import SEO from "components/SEO/SEO";
import CommonEditorFileTemplate1 from "../common-component/common-editor-file/CommonEditorFileTemplate1";
import CommonEditorFileTemplate2 from "../common-component/common-editor-file/CommonEditorFileTemplate2";
import CommonEditorFileTemplate3 from "../common-component/common-editor-file/CommonEditorFileTemplate3";
import CommonEditorFileTemplate4 from "../common-component/common-editor-file/CommonEditorFileTemplate4";

function BusinessImprovementProgram() {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [metaData, setMetaData] = useState();
  const { Slug } = useParams();
  const { pathname } = useLocation();
  const containerRef = useRef(null);

  const fetchData = async () => {
    setLoading(true);
    const response = await fetch(`${API_BASE_URL}pages/get/slug/${Slug}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    setLoading(false);
    setData(data?.data[0]);
    console.log("data pages", data);

    if (data?.data?.[0]) {
      const pageData = data.data[0];
      setMetaData({
        pageTitle: pageData?.metatitle,
        description: pageData?.metadescription,
        pageKeyword: pageData?.metakeywords?.join(","),
      });
    }

    if (!response.ok) {
      // message.error(data.message);
      throw new Error(data.message);
    }

    // return data.data;
  };

  useEffect(() => {
    if (Slug) {
      fetchData();
    }
  }, [Slug]);

  console.log(metaData, "metaData");
  return (
    <>
      {metaData && <SEO seo={metaData && metaData} />}
      <div ref={containerRef}>
        <CommonEditorFile data={data} title={data?.name} loading={loading} />
        {/* <CommonEditorFileTemplate1
          data={data}
          title={data?.name}
          loading={loading}
        /> */}
        {/* <CommonEditorFileTemplate2
          data={data}
          title={data?.name}
          loading={loading}
        /> */}
        {/* <CommonEditorFileTemplate3
          data={data}
          title={data?.name}
          loading={loading}
        /> */}
        {/* <CommonEditorFileTemplate4
          data={data}
          title={data?.name}
          loading={loading}
        /> */}
        {/* <button onClick={scrollToTop}>Click me</button> */}
      </div>
    </>
  );
}

export default BusinessImprovementProgram;
